const state = {
    contact:{fullname:''},
};

const getters = {
    getContact: state => state.contact,
};

const actions = {
    setContact: (store, payload) => store.commit("CONTACT_SET",payload),
};

const mutations = {
    CONTACT_SET: (state, payload) => state.contact = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
